import { AvvirEvent } from "type_aliases";

export type PushToProcoreDialogShownEvent = AvvirEvent<typeof PUSH_TO_PROCORE_DIALOG_SHOWN, { procoreAccessToken: any, pdfType: any, selectedElements:any }>

const pushToProcoreDialogShown = (procoreAccessToken, pdfType , selectedElements): PushToProcoreDialogShownEvent => ({
  type: PUSH_TO_PROCORE_DIALOG_SHOWN,
  payload: {
    procoreAccessToken,
    pdfType,
    selectedElements
  }
});

export const PUSH_TO_PROCORE_DIALOG_SHOWN = "push_to_procore_dialog_shown";

export default pushToProcoreDialogShown;
